import React from "react";

function DetailRow({ title, value }) {
  return (
    <div className="w-100 d-flex justify-content-start gap-2 text-black">
      <p className="gray-text">{title}:</p>
      <p className="fw-bold">{value}</p>
    </div>
  );
}

export default DetailRow;
